/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archival_SavedInputs */



/**
* | output |
* | --- |
* | "Archival results saved" |
*
* @param {Archival_SavedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const archival_saved = /** @type {((inputs?: Archival_SavedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archival_SavedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Résultats d'archive enregistrés")
	if (locale === "es") return /** @type {LocalizedString} */ ("Resultados de archivo guardados")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Resultados de arquivo salvos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Risultati d'archivio salvati")
	return /** @type {LocalizedString} */ ("Archival results saved")
});